import React, { ChangeEvent } from "react";
import { makeStyles, TextField as MaterialTextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  focused: {
    borderRadius: 4,
    "& .MuiFilledInput-root": {
      borderRadius: 4,
      "&.Mui-focused": {
        border: `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: theme.palette.secondary.light,
      },
    },
  },
}));

type TextFieldProps = {
  value: string;
  name: string;
  autoFocus?: boolean;
  disabled?: boolean;
  type?: string;
  onChange?: (e: ChangeEvent<any>) => any;
  minRows?: number;
  multiline?: boolean;
  fullWidth?: boolean;
};

export default function TextField({
  name: name,
  value: value,
  ...props
}: TextFieldProps) {
  const classes = useStyles();
  return (
    <MaterialTextField
      {...props}
      variant="filled"
      InputProps={{ disableUnderline: true }}
      className={classes.focused}
      value={value}
      name={name}
    />
  );
}
